import { CREDITS } from "../data/site";
import useReveal from "../hooks/useReveal";

function CreditList({ items, testIdPrefix }) {
  return (
    <ul className="space-y-0">
      {items.map((c, i) => (
        <li
          key={`${c.year}-${c.project}-${i}`}
          data-testid={`${testIdPrefix}-${i}`}
          className="grid grid-cols-12 gap-3 sm:gap-6 py-5 border-b border-white/5 hover:bg-white/[0.02] transition-colors group"
        >
          <div className="col-span-3 sm:col-span-2 overline text-[#D4AF37] pt-1">{c.year}</div>
          <div className="col-span-9 sm:col-span-5">
            <div className="font-serif-display italic text-xl sm:text-2xl text-white leading-tight">
              {c.project}
            </div>
            <div className="text-xs sm:text-sm text-[#6B6B72] mt-1">{c.venue}</div>
          </div>
          <div className="col-span-12 sm:col-span-5 text-[#A0A0A8] text-sm sm:text-base sm:text-right pt-1 group-hover:text-white transition-colors">
            {c.role}
          </div>
        </li>
      ))}
    </ul>
  );
}

export default function Credits() {
  const ref = useReveal();
  return (
    <section
      id="credits"
      data-testid="credits-section"
      className="relative py-28 sm:py-36 lg:py-44 grain"
    >
      <div ref={ref} className="reveal max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="mb-16">
          <div className="overline text-[#991B1B] mb-6">— Credits</div>
          <h2
            data-testid="credits-title"
            className="font-serif-display text-5xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[0.95]"
          >
            Selected <span className="italic text-[#A0A0A8]">work.</span>
          </h2>
        </div>

        <div className="space-y-20">
          <div>
            <div className="flex items-center gap-6 mb-6">
              <h3 className="font-serif-display text-3xl text-white">Theatre</h3>
              <div className="divider-line flex-1" />
            </div>
            <CreditList items={CREDITS.theatre} testIdPrefix="credit-theatre" />
          </div>

          <div>
            <div className="flex items-center gap-6 mb-6">
              <h3 className="font-serif-display text-3xl text-white">Film & Screen</h3>
              <div className="divider-line flex-1" />
            </div>
            <CreditList items={CREDITS.film} testIdPrefix="credit-film" />
          </div>

          <div>
            <div className="flex items-center gap-6 mb-6">
              <h3 className="font-serif-display text-3xl text-white">Training</h3>
              <div className="divider-line flex-1" />
            </div>
            <CreditList items={CREDITS.training} testIdPrefix="credit-training" />
          </div>

          <div>
            <div className="flex items-center gap-6 mb-6">
              <h3 className="font-serif-display text-3xl text-white">Awards & Honours</h3>
              <div className="divider-line flex-1" />
            </div>
            <ul className="space-y-0">
              {CREDITS.awards.map((a, i) => (
                <li
                  key={i}
                  data-testid={`credit-award-${i}`}
                  className="grid grid-cols-12 gap-3 sm:gap-6 py-5 border-b border-white/5 hover:bg-white/[0.02] transition-colors"
                >
                  <div className="col-span-3 sm:col-span-2 overline text-[#D4AF37] pt-1">{a.year}</div>
                  <div className="col-span-9 sm:col-span-10">
                    <div className="font-serif-display italic text-xl sm:text-2xl text-white leading-tight">
                      {a.title}
                    </div>
                    <div className="text-xs sm:text-sm text-[#A0A0A8] mt-1">{a.detail}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="flex items-center gap-6 mb-6">
              <h3 className="font-serif-display text-3xl text-white">Skills</h3>
              <div className="divider-line flex-1" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-3">
              {CREDITS.skills.map((s, i) => (
                <div
                  key={s}
                  data-testid={`credit-skill-${i}`}
                  className="flex items-center gap-3 py-2 border-b border-white/5"
                >
                  <span className="text-[#991B1B] text-xs">◆</span>
                  <span className="text-[#A0A0A8] text-sm sm:text-base">{s}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <p className="mt-12 text-xs text-[#6B6B72] italic">
          Full résumé with references available for download in the next section.
        </p>
      </div>
    </section>
  );
}
